export enum ContractType {
  NotSet = 'NotSet',
  Equivalent = 'Equivalent',
  Basic = 'Basic',
  Task = 'Task',
  Mix = 'Mix',
  Intermittent = 'Intermittent',
  CivilLawAgreement = 'CivilLawAgreement',
  SelfEmployment = 'SelfEmployment',
}
